import _extends from "@babel/runtime/helpers/esm/extends";
import exctractPriceFieldsFromProduct from './exctractPriceFieldsFromProduct';
import extractQuantityFieldsFromProduct from './extractQuantityFieldsFromProduct';
export default function createSubjectWithoutProductResolving(partial) {
  return _extends({
    product: null,
    // Enforce validation error if product is not present in partial object.
    quantity: 1,
    price: 0,
    priceOriginal: undefined,
    priceWithTax: 0,
    priceOriginalWitTax: undefined,
    discountAbsolute: undefined,
    discountPercent: undefined
  }, exctractPriceFieldsFromProduct((partial || {}).product), extractQuantityFieldsFromProduct((partial || {}).product), partial);
}